export const iconFontAwesomeArrowsUpDown = (
	<i className="fa-solid fa-up-down"></i>
);
